"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInfoRecom = exports.getInfoRecomError = exports.getSEO = exports.getByName = exports.getByNameError = void 0;

var _telcoApi = require("../../../apis/telcoApi");

var _gerenciatdUtils = require("@bit/gerenciatd.utils.monitoring-utils");

var _gerenciatdUtils2 = _interopRequireDefault(require("@bit/gerenciatd.utils.request"));

var _gerenciatdUtils3 = _interopRequireWildcard(require("@bit/gerenciatd.utils.sonda"));

var _gerenciatdAdabyronUtils = require("@bit/gerenciatd.adabyron-utils.error");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var processName = 'ADABYRON-API';
/* GET BY NAME */

var newTabOpen = 0;

var getByNameError = function getByNameError() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var envName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var endpoint = arguments.length > 2 ? arguments[2] : undefined;

  // const objError = normalizeObjError(req);
  // opentab fot custo session
  if (!newTabOpen && envName === 'qa' && req && req.statusText === 'Network Error') {
    newTabOpen = 1;

    try {
      window.open(endpoint);
    } catch (err) {
      console.log("[Error Opening Custo Tab]: ".concat(err));
    }
  }
  /* si el normalizador no consigue meter un response
  if (objError && !objError.response) {
    objError.response = {
      error: true
    };
  }
  */

};

exports.getByNameError = getByNameError;

var getByName = function getByName(data) {
  var kind = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'activity';
  var idFront = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'VT';

  var idRequest = _gerenciatdUtils.api.getUUID(idFront);

  var context = data && data.context || {};
  var sonda = new _gerenciatdUtils3["default"]('CUSTOMIZER.ACTIVITY.GETBYNAME', processName, context);
  var _context$environment = context.environment,
      envName = _context$environment.name,
      custo = _context$environment.custo;
  var host = custo.endpoint,
      headers = custo.headers;
  var endpoint = "".concat(host).concat(_telcoApi.API.CUSTOMIZER.GET_BY_NAME.replace(':kind', kind), "?").concat(idRequest);

  try {
    var request = new _gerenciatdUtils2["default"]({
      method: 'POST',
      endpoint: endpoint,
      data: data,
      onError: function onError(req) {
        return getByNameError(req, envName, endpoint);
      },
      sonda: sonda,
      headers: headers
    });
    return request.makeRequest();
  } catch (err) {
    sonda.endWS(_gerenciatdUtils3.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};
/*
SEO API
INPUT SHAPE: data = {
  SEG_NAV: 'particulares'
  location: 'www.movistar.es'
  customValues: '' // help to specific product
} */
// EVENTS FUNCTIONS END
// REQUEST METHOD BEGINS


exports.getByName = getByName;

var getSEO = function getSEO(data) {
  var idFront = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'VT';

  var idRequest = _gerenciatdUtils.api.getUUID(idFront);

  var context = data && data.context || {};
  var sonda = new _gerenciatdUtils3["default"]('CUSTOMIZER.SEO.GETBYOBJ', processName, context, idRequest);
  var connectionData = context.environment.custo;
  var host = connectionData.endpoint,
      headers = connectionData.headers;
  var endpoint = "".concat(host).concat(_telcoApi.API.CUSTOMIZER.GET_SEO_BY_OBJ, "?").concat(idRequest);

  try {
    var request = new _gerenciatdUtils2["default"]({
      method: 'POST',
      endpoint: endpoint,
      data: data,
      sonda: sonda,
      headers: headers
    });
    return request.makeRequest();
  } catch (err) {
    sonda.endWS(_gerenciatdUtils3.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
}; // REQUEST METHOD ENDS

/*
InfoRecomApi
INPUT SHAPE: data = {
  SEG_NAV: 'particulares'
  location: 'www.movistar.es'
  customValues: '' // help to specific product
} */


exports.getSEO = getSEO;

var getInfoRecomError = function getInfoRecomError() {
  var req = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var endpoint = arguments.length > 1 ? arguments[1] : undefined;
  var objError = (0, _gerenciatdAdabyronUtils.normalizeObjError)(req); // si el normalizador no consigue meter un response

  if (objError && !objError.response) {
    objError.response = {
      error: true
    };
  }
};

exports.getInfoRecomError = getInfoRecomError;

var getInfoRecomSuccess = function getInfoRecomSuccess(data) {
  if (data.infoRecom && data.infoRecom.ctz_businessClusters) {
    return {
      infoRecom: _objectSpread({}, data.infoRecom, {
        'ctz_businessClusters': JSON.parse(data.infoRecom.ctz_businessClusters) || []
      })
    };
  }

  return null;
};

var getInfoRecom = function getInfoRecom(data) {
  var idFront = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'VT';

  var idRequest = _gerenciatdUtils.api.getUUID(idFront);

  var context = data && data.context || {};
  var sonda = new _gerenciatdUtils3["default"]('CUSTOMIZER.GET_INFO_RECOM', processName, context, idRequest);
  var custo = context.environment.custo;
  var host = custo.endpoint,
      headers = custo.headers;
  var endpoint = "".concat(host).concat(_telcoApi.API.CUSTOMIZER.GET_INFO_RECOM, "?").concat(idRequest);
  var dataEntry = {
    ga: context.clientIDs.ga ? context.clientIDs.ga : '',
    pageId: context.clientIDs.pageId || 'sinPageId',
    session: context.clientIDs.sessId || null,
    url: window.location.href,
    context: context
  };

  try {
    var request = new _gerenciatdUtils2["default"]({
      method: 'POST',
      endpoint: endpoint,
      data: dataEntry,
      onError: function onError(req) {
        return getInfoRecomError(req);
      },
      onSuccess: function onSuccess(response) {
        return getInfoRecomSuccess(response);
      },
      sonda: sonda,
      headers: headers
    });
    return request.makeRequest();
  } catch (err) {
    sonda.endWS(_gerenciatdUtils3.CD_ELEMENT_TYPE.JS_ERROR);
    return null;
  }
};

exports.getInfoRecom = getInfoRecom;

//# sourceMappingURL=index.js.map